export enum ECRMIds {
    INSTANT_MESSAGING = 'instant-messaging',
    FUNNELS = 'all-funnels',
    AUTOMATIONS = 'automations',
    WEBHOOK_SETTINGS = 'webhook-settings',
};

export const CRMPageFragments = [
    {
        id: ECRMIds.INSTANT_MESSAGING,
        title: 'CRM.SETTINGS.INSTANT_MESSAGING',
    },
    {
        id: ECRMIds.FUNNELS,
        title: 'CRM.ALL_FUNNELS.FUNNELS',
    },
    {
        id: ECRMIds.AUTOMATIONS,
        title: 'CRM.AUTOMATIONS.AUTOMATIONS',
    },
    {
        id: ECRMIds.WEBHOOK_SETTINGS,
        title: 'CRM.SETTINGS.WEBHOOK_SETTINGS',
    }
];